import script from "./limits-component.vue?vue&type=script&setup=true&lang=js"
export * from "./limits-component.vue?vue&type=script&setup=true&lang=js"

import "./limits-component.vue?vue&type=style&index=0&id=de692ad8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de692ad8"]])

export default __exports__